<!--
 * @Author: cryi.liu
 * @Date: 2020-05-08 14:05:00
 * @LastEditTime: 2020-06-14 10:59:31
 * @Description: 大题板块总览
 -->
<template>
  <div class="big-question-overview">
    <p v-if="enableDeleteBtn" class="action">
      <i-icon type="md-trash" size="24" @click="clickDeleteBigQuestionBtnHandler" />
    </p>
    <p class="score">
      <span>每题分数</span>
      <i-input-number
        size="small"
        :disabled="!enableScoreInput"
        :min="0"
        :step="1" :value="score" @on-change="inputScoreChangedHandler" />
      <span>分</span>
    </p>
    <p class="info">
      <span>共{{ count }}题</span>，
      <span>总分{{ totalScore }}分</span>
    </p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { debounce } from '../../../../../utils';

export default {
  name: 'BigQuestionOverview',
  props: {
    partId: { type: String, required: false, default: '' },
    count: { type: Number, required: false, default: 0 },
    score: { type: Number, required: false, default: 0 },
    type: { type: String, reuqired: false },
    required: { type: Boolean, required: false },
  },
  data() {
    return {
      vm: this,
      tempScore: 0,
    };
  },
  computed: {
    ...mapGetters({
      paperId: 'createPaperStore/paperId',
    }),
    totalScore() {
      return this.count * this.score;
    },
    enableDeleteBtn() {
      return this.type !== 'empty';
    },
    enableScoreInput() {
      return this.type !== 'empty';
    },
  },
  watch: {
    score: {
      immediate: true,
      handler(value) {
        this.tempScore = value;
      },
    },
  },
  methods: {
    ...mapActions({
      setPaperId: 'createPaperStore/invokeSetPaperId',
      setPaperName: 'createPaperStore/invokeSetPaperName',
      setBigQuestions: 'createPaperStore/invokeSetBigQuestions',
    }),
    /**
     * 点击删除大题板块按钮处理函数
     */
    clickDeleteBigQuestionBtnHandler() {
      // if (!this.required) {
      this.requestDeleteBigQuestionAndSetting();
      // } else {
      //
      //   alert('必考题不能删除');
      // }
    },
    /**
     * 分数输入框数值改变处理函数
     */
    inputScoreChangedHandler(score) {
      this.tempScore = score;

      if (Number.isInteger(this.tempScore)) {
        this.requestSetBigQuestionScoreAndSettings();
      }
    },
    /**
     * 请求保存设置大题板块分数并设置
     */
    requestSetBigQuestionScoreAndSettings: debounce(function () {
      this.requestSetBigQuestionScore()
        .then((result) => {
          this.setPaperId({ paperId: result.paper.id });
          this.setPaperName({ paperName: result.paper.name });
          this.setBigQuestions({ bigQuestions: result.result });
        })
        .catch((result) => {
          alert(result.msg);
        });
    }, 300),
    /**
     * 请求保存设置大题板块分数
     */
    requestSetBigQuestionScore() {
      const params = {
        paperId: this.paperId,
        partId: this.partId,
        score: this.tempScore,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.paperCreateSetScore(params);

        if (result.code === '200') {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 请求删除试卷大类并设置
     */
    requestDeleteBigQuestionAndSetting() {
      this.requestDeleteBigQuestion()
        .then((result) => {
          this.setBigQuestions({ bigQuestions: result.result });
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求删除试卷大题板块
     */
    requestDeleteBigQuestion() {
      const params = {
        paperId: this.paperId,
        partId: this.partId,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.paperCreateDeleteBigQuestion(params);

        if (result.code === '200') {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.big-question-overview {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 180px;
  height: 180px;
  padding: 30px 20px;
  border-radius: 4px;
  background-color: #e8ecf7;
  border: 1px solid #ddd;

  > .action {
    position: absolute;
    top: 12px;
    right: 8px;
    display: flex;
    justify-content: flex-end;

    > i {
      cursor: pointer;
    }
  }

  > .score {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    /deep/ .ivu-input-number {
      margin: 0 6px;
      width: 56px;
    }
  }
}
</style>
